import { SETTLING_ASSET } from 'constants/currency';
import { ChartSupportedAssets } from 'types/actions/charts';

const tooltipStyle = `
 color: var(--brand-text-primary); 
 border-top: 1px solid var(--primaryTheme); 
 width: 100%;
 padding-top: 8px;
 margin-top: 8px;`;

const flexRowAlignStyle = `
 display: flex;
 align-items: center;   
 gap: 8px;
`;

const flexColumnAlignStyle = `
 display: flex;
 flex-direction: column;
`;

const PRIORITY_ORDER = ['d1', 'w1', 'm1', 'd2', 'w2', 'm2', 'd3', 'w3', 'm3'];

const ASSETS_LIST = [SETTLING_ASSET.BTC, SETTLING_ASSET.ETH];
const ASSET_SYMBOLS: Record<ChartSupportedAssets, ChartSupportedAssets> = {
  BTC: 'BTC',
  ETH: 'ETH',
};

const emptyChartOptions = {
  chart: {
    type: undefined,
    height: 500,
  },
  title: {
    text: undefined,
  },
  xAxis: {
    categories: [],
  },
  yAxis: {
    title: {
      text: undefined,
    },
  },
  series: [],
  plotOptions: {},
  tooltip: {},
  legend: {},
  credits: {
    enabled: false,
  },
};

// Object representing the default properties for the highest volume
const EMPTY_HIGHEST_VOLUME_PROPS = {
  volume: 0,
  productId: -1,
  contractSymbol: '',
};

export {
  emptyChartOptions,
  tooltipStyle,
  flexRowAlignStyle,
  flexColumnAlignStyle,
  PRIORITY_ORDER,
  ASSET_SYMBOLS,
  EMPTY_HIGHEST_VOLUME_PROPS,
  ASSETS_LIST,
};

